export default __webpack_public_path__ + "static/media/blog-arturoFuente.cf6b0beb.png";